export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    month = "",
    year = "",
    creditAccountLabels = [],
    rows = [],
    totals = {},
    recordedToLedgerDay = "",
    recordedToLedgerMonth = "",
    recordedToLedgerYear = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const rowHtml = rows.map((r) => `
    <tr>
      <td class="border text-center">${r.index || ""}</td>
      <td class="border text-center">${r.debitAccountCode || ""}</td>
      <td class="border px-1">${r.debitAccountName || ""}</td>
      ${(r.creditValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
      <td class="border text-right px-1 font-bold bg-light">${fmt(r.rowTotal)}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 10px; color: black; line-height: 1.2;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span class="dotted-line">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span class="dotted-line">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S04a8-DN</div>
            <div style="font-style: italic; font-size: 9px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 10px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 14px;">NHẬT KÝ CHỨNG TỪ SỐ 8</h2>
        <div style="font-weight: bold; font-size: 11px;">Ghi Có các TK: 155, 156, 157, 158, 131, 511, 515, 521, 632, 635, 641, 642, 711, 811, 821, 911</div>
        <div style="margin-top: 5px; font-weight: bold;">
          Tháng ${month} năm ${year}
        </div>
      </div>

      <table width="100%" style="border-collapse: collapse; table-layout: fixed;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="25">Số TT</th>
            <th class="border" rowspan="2" width="50">Số hiệu TK ghi Nợ</th>
            <th class="border" rowspan="2" width="180">Các TK ghi Nợ</th>
            <th class="border" colspan="16">Các TK ghi Có</th>
            <th class="border" rowspan="2" width="80">Cộng</th>
          </tr>
          <tr>
            ${creditAccountLabels.map(l => `<th class="border" width="65">${l || "..."}</th>`).join("")}
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            ${[...Array(16)].map((_, i) => `<th class="border">${i+1}</th>`).join("")}
            <th class="border">17</th>
          </tr>
        </thead>
        <tbody>
          ${rowHtml}
          <tr class="font-bold bg-light">
            <td class="border text-center" colspan="3">Cộng</td>
            ${(totals.creditValues || []).map(v => `<td class="border text-right px-1">${fmt(v)}</td>`).join("")}
            <td class="border text-right px-1">${fmt(totals.grandTotal)}</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 10px;">
        Đã ghi sổ cái ngày <span class="font-bold">${recordedToLedgerDay}</span> tháng <span class="font-bold">${recordedToLedgerMonth}</span> năm <span class="font-bold">${recordedToLedgerYear}</span>
      </div>

      <table width="100%" style="margin-top: 20px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 40px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 40px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 3px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 40px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 0.5pt solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 2px; }
        .bg-light { background-color: #f9f9f9; }
        .dotted-line { border-bottom: 0.5pt dotted black; }
        @media print {
            @page { size: A4 landscape; margin: 0.5cm; }
            body { -webkit-print-color-adjust: exact; }
        }
      </style>
    </div>
  `;
};
